import type { Portal } from '@angular/cdk/portal';
import { Injectable, signal, untracked } from '@angular/core';

/**
 * The one place in the application header a Clarity surface may render into. The shell owns the
 * outlet, after the AI Assistant toggle, so the header lays the content out in its own flex row
 * instead of a floating overlay drawing over it.
 *
 * One claimant at a time: a second `claim` replaces the first, and `release` clears the slot only
 * for the portal that holds it, so a stale release cannot evict a newer claimant.
 */
@Injectable({ providedIn: 'root' })
export class ClarityTopBarSlot {
	private readonly content = signal<Portal<unknown> | null>(null);

	public readonly portal = this.content.asReadonly();

	public claim(portal: Portal<unknown>): void {
		this.content.set(portal);
	}

	public release(portal: Portal<unknown>): void {
		if (untracked(this.content) === portal) {
			this.content.set(null);
		}
	}
}
